// 购买渠道管理
import http from "@/jslibs/axios/http";

// 购买渠道更新
export const edit = (data) => http.post("/v1/cms/BuyPath", data);

// 购买渠道详情
export const detail = (data) => http.get("/v1/cms/BuyPath", data);
